import { API_COMMON } from "@/shared/server/apis";
import { QUERY_KEY } from "@/shared/server/keys";
import { useQuery } from "@tanstack/react-query";

export const useGetCommon = <T>(params: { [key: string]: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_COMMON_INFO, params],
        queryFn: () => API_COMMON.getCommonInfo<T>(params),
    });

    return { data, isLoading };
};
export const useGetDMaxCommon = <T>(params: { [key: string]: string }) => {
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_DMAX_COMMON_INFO, params],
        queryFn: () => API_COMMON.getDMaxCommonInfo<T>(params),
    });
    return { data, isLoading };
};
